import { STATUSES } from '../../../../constants/flows';

const ACTIVE_STATUSES = [STATUSES.ACTIVE, STATUSES.NEEDS_CONFIG];

export { ACTIVE_STATUSES };
